import { EditIcon, EyeIcon, QuestionMarkCircleIcon, TrashIcon } from "assets";
import {
  Card,
  CustomTooltip,
  FullScreenModal,
  SmallScreenModel,
} from "components";
import React, { useState } from "react";
import { PackageProps } from "../store/actionType";
import PreviewCard from "./components/PackageCard";
import UpdatePackage from "./manage_package/UpdatePackage";
import DeletePackage from "./manage_package/DeletePackage";
import MembershipDurationByPackageId from "../../membership_duration/MembershipDurationByPackageId";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

const ActionButton: React.FC<{ items: PackageProps }> = ({ items }) => {
  const [viewCard, setViewCard] = useState(false);
  const [isEditModel, setEditModel] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const [isMembershipDurationOpen, setMembershipDurationOpen] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_COMMERCIAL_PACKAGE));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Preview" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setViewCard(true)}
            >
              <EyeIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Edit" placement="bottom">
            <button
              className="hover:text-primary-500"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-red-500"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon className="" />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Membership Duration" placement="bottom">
            <button
              className="hover:text-blue-500"
              onClick={() => setMembershipDurationOpen(true)}
            >
              <QuestionMarkCircleIcon className="" />
            </button>
          </CustomTooltip>
        </div>
        {viewCard && (
          <Card showCard={viewCard} setShowCard={setViewCard}>
            <PreviewCard items={items} />
          </Card>
        )}
        <SmallScreenModel setShowModal={setEditModel} showModal={isEditModel}>
          <UpdatePackage packageData={items} closeModal={setEditModel} />
        </SmallScreenModel>
        <SmallScreenModel
          setShowModal={setDeleteModel}
          showModal={isDeleteModel}
        >
          <DeletePackage packageData={items} closeModal={setDeleteModel} />
        </SmallScreenModel>
        <FullScreenModal
          setShowModal={setMembershipDurationOpen}
          showModal={isMembershipDurationOpen}
        >
          <MembershipDurationByPackageId
            package_id={items.id}
            tableHeader={[
              "Membership Plan",
              "Packages",
              "Membership Durations",
            ]}
          />
        </FullScreenModal>
      </>
    );
  return <></>;
};

export default ActionButton;
